module.exports = __webpack_public_path__ + "static/media/djavulssopp.37bff4e6.jpeg";